import React, { useMemo } from 'react';
import { Button, Descriptions, Modal, Space, Typography } from 'antd';
import IntlMessage from '../../../components/IntlMessage';
import dayjs from 'dayjs';
import { mapCountry } from '../../../helpers/helpers';

const { Text } = Typography;

const CustomerDetails = (props) => {
  const { onClose, currentData = {} } = props;
  const handleCancel = () => {
    onClose();
  };

  const countryData = useMemo(mapCountry, []);

  return (
    <>
      <Modal
        open={true}
        width={'60%'}
        destroyOnClose={true}
        onCancel={handleCancel}
        onOk={handleCancel}
        footer={[
          <Button key="back" type="default" onClick={handleCancel}>
            {<IntlMessage id="global.cancel" />}
          </Button>,
        ]}
      >
        <Descriptions
          title={<IntlMessage id="global.information_customer" />}
          bordered
        >
          <Descriptions.Item
            label={
              <>
                <IntlMessage id="global.firstname" /> -{' '}
                <IntlMessage id="global.lastname" />
              </>
            }
            span={2}
            // labelStyle={{ width: '20%' }}
          >
            {currentData?.fullname}
          </Descriptions.Item>
          <Descriptions.Item
            label={<IntlMessage id="global.created_at" />}
            span={2}
            labelStyle={{ width: '22%' }}
          >
            <Text>
              {dayjs(currentData?.created_at).format('DD/MM/YYYY HH:mm')}
            </Text>
          </Descriptions.Item>
          <Descriptions.Item
            span={2}
            label={<IntlMessage id="global.mobile" />}
          >
            {currentData.phone_code
              ? `${currentData.phone_code}${currentData.mobile.slice(1)}`
              : currentData.mobile}
          </Descriptions.Item>
          <Descriptions.Item
            label={<IntlMessage id="global.country" />}
            span={2}
            labelStyle={{ width: '22%' }}
          >
            <Space>
              <Text>
                {countryData.get(currentData?.phone_code?.slice(1))?.country} (
                {currentData?.phone_code})
              </Text>
            </Space>
          </Descriptions.Item>
          <Descriptions.Item span={3} label={<IntlMessage id="global.email" />}>
            {currentData?.email}
          </Descriptions.Item>
          {/* <Descriptions.Item
            label={<IntlMessage id="global.company_tax_id" />}
            span={2}
            labelStyle={{ width: '20%' }}
          >
            {currentData?.company_tax_id}
          </Descriptions.Item> */}
          <Descriptions.Item
            span={3}
            label={<IntlMessage id="global.address" />}
          >
            {currentData?.address}
          </Descriptions.Item>
          {/* <Descriptions.Item
            span={3}
            label={<IntlMessage id="global.cgroup" />}
          >
            {currentData?.cgroup?.title}
          </Descriptions.Item> */}
        </Descriptions>
      </Modal>
    </>
  );
};

export default CustomerDetails;
